import { createSlice } from '@reduxjs/toolkit';

export const languageSlice = createSlice({
  name: 'language',
  initialState: {
    current: 'es',
    mode: 'single',
    default: 'es',
    languages: []
  },
  reducers: {
    setLanguage: (state, action) => {
      state.current = action.payload;
    },
    setLanguageMode: (state, action) => {
      state.mode = action.payload;
    },
    setDefaultLanguage: (state, action) => {
      state.default = action.payload;
    },
    setLanguages: (state, action) => {
      state.languages = action.payload;
    }
  },
  selectors: {
    selectLanguage: (state) => state.current,
    selectLanguageMode: (state) => state.mode,
    selectDefaultLanguage: (state) => state.default,
    selectLanguages: (state) => state.languages
  }
});

export const { setLanguage, setLanguageMode, setDefaultLanguage, setLanguages } = languageSlice.actions;

export const { selectLanguage, selectLanguageMode, selectDefaultLanguage, selectLanguages } = languageSlice.selectors;

export default languageSlice.reducer;
